import { render, staticRenderFns } from "./HtmlV1Properties.vue?vue&type=template&id=8d6e1f90&"
import script from "./HtmlV1Properties.vue?vue&type=script&lang=js&"
export * from "./HtmlV1Properties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports